import FJUtil from '../util/FJUtil';

let _currentKeyword = null;
let _nextPage = null;

let prefix = FJUtil.isLocalhost() ? 'https://www.smartvideomaker.com' : '';
let cache = new Map();

const FJTheNounProject = {

  /**
   * 搜索
   * @param keyword
   * @param page
   * @returns {Promise<[]>}
   */
  search: async function (keyword, page = 1) {
    let result;
    try {
      let response = await fetch(`${prefix}/icon/search?key=${keyword}&page=${page}`, {mode: 'cors',});
      let data = await response.json();
      _nextPage = page + 1;
      _currentKeyword = keyword;
      result = await this._filterSvg(data.data);
      result.forEach(item => {
        const {id, svg} = item;
        if (!cache.has(id)) {
          cache.set(id, svg);
        }
      })
    } catch (e) {
      if (e.message === 'Failed to fetch')
        throw e;
      _nextPage = null;
      result = null
    }
    return result;
  },

  /**
   * 查询下一页
   * @returns {Promise<boolean|*>}
   */
  nextPage: async function () {
    if (!_nextPage) {
      return null;
    }
    return this.search(_currentKeyword, _nextPage);
  },

  fetchByID: async function (id) {
    if (cache.has(id)) {
      return cache.get(id);
    } else {
      let response = await fetch(`${prefix}/icon/get?iconId=${id}`).then((response) => {
        return response;
      }).catch(e => {
        console.log(e);
        return null;
      });
      if (response) {
        let data = await response.json();
        let svg = await this._fetchSvg(data.data.icon_url);
        cache.set(id, svg);
        return svg;
      }
    }
  },

  _fetchSvg: async function (url) {
    let response = await fetch(url).then((response) => {
      return response;
    }).catch(e => {
      console.log(e);
      return null;
    });
    if (response) {
      let text = await response.text();
      let data = text.replace(/<switch/g, "<g");
      data = data.replace(/switch>/g, "g>");
      let svg = FJUtil.decodeSvg(data);
      if (svg) {
        FJUtil.parseSVGWithStyle(svg);
        if (!FJUtil.isIneffectivenessSVG(svg)) {
          FJUtil.svgConvertToCompoundPathSVG(svg);
          if ((svg.hasAttribute("width") && svg.getAttribute("width") === "0") ||
            (svg.hasAttribute("height") && svg.getAttribute("height") === "0") ||
            (svg.hasAttribute("viewBox") && svg.getAttribute("viewBox") === "0 0 0 0")) {
            return null;
          } else {
            return svg;
          }
        }
      }
    }
  },

  /**
   * 过滤出符合条件的svg
   * @param data
   * @private
   */
  _filterSvg: async function (data) {
    if (!data) {
      return null;
    }
    let result = [];
    let promises = [];
    data.forEach(item => {
      let temp = item;
      let func = new Promise((resolve) => {
        this._fetchSvg(temp.icon_url).then(svg => {
          if (svg && svg.innerHTML) {
            temp.svg = svg;
            temp.icon_url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
            result.push(temp);
          }
          resolve();
        }).catch(resolve)
      });
      promises.push(func);
    });

    await Promise.all(promises);
    return result;
  }
};

export default FJTheNounProject;